// extracted by mini-css-extract-plugin
export default {"onboarding-flow":"onboarding-flow_onboarding-flow__0Px7Z"};